import { Route, Routes } from 'react-router-dom';

import { HttpClientInterceptorProvider } from '@hd/http-client/HttpClientInterceptorProvider';
import HubProvider from '@hd/hub/HubProvider';

import { PrivateRoute } from './core/auth/PrivateRoute';
import LayoutPage from './core/layout/Layout';
import LegacyHdBridgePage from './core/legacy-hd-bridge/LegacyHdBridgePage';
import useCommunicationRoutes from './features/communications/useCommunicationRoutes';
import useConciergeRoutes from './features/concierge/useConciergeRoutes';
import useDooryRoutes from './features/doory/useDooryRoutes';
import useLoginRoutes from './features/login/useLoginRoutes';
import usePersonsRoutes from './features/persons/usePersonsRoutes';
import useReportsRoutes from './features/reports/useReportsRoutes';
import useLegacyRedirectRoutes from "./core/legacy-hd-bridge/useLegacyRedirectRoutes";

function AppRoutes() {
  const LoginRoutes = useLoginRoutes();
  const PersonsRoutes = usePersonsRoutes();
  const ConciergeRoutes = useConciergeRoutes();
  const DooryRoutes = useDooryRoutes();
  const ReportsRoutes = useReportsRoutes();
  const CommunicationRoutes = useCommunicationRoutes();
  const LegacyRedirectRoutes = useLegacyRedirectRoutes();
  return (
    <HttpClientInterceptorProvider>
      <Routes>
        {LoginRoutes}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <HubProvider>
                <LayoutPage />
              </HubProvider>
            </PrivateRoute>
          }
        >
          {PersonsRoutes}
          {ConciergeRoutes}
          {DooryRoutes}
          {ReportsRoutes}
          {CommunicationRoutes}
          {LegacyRedirectRoutes}
          <Route path="/" element={<LegacyHdBridgePage />} />
          <Route path="*" element={<LegacyHdBridgePage />} />
        </Route>
      </Routes>
    </HttpClientInterceptorProvider>
  );
}

export default AppRoutes;
